//
// Forked from formatSymbol.js to add types and comments. Implementation likely to drift as time
// goes on. See original:
// https://github.com/observablehq/inspector/blob/e88c0459a71f9bcfd8c22b8c78262f71979821b2/src/formatSymbol.js
//

/**
 * Takes a Symbol and returns a string representation formatted in the style of the Chrome devtools
 * JS console.
 */
export function formatSymbol(symbol: symbol): string {
	// NOTE: Symbols do not coerce to strings; they must be explicitly converted. Use Error's
	// implementation of `toString` to prevent overriding by subclasses.
	const symbolToString = Symbol.prototype.toString;
	return symbolToString.call(symbol);
}
